import { format } from 'date-fns'
import React from 'react'

import { useLogisticFilters } from 'hooks/useLogisticFilters'
import { logisticApi } from 'redux/services/logistic'
import { LogisticShortObject } from 'redux/services/logistic/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { LOGISTIC_STATUS_TEXT } from 'constants/logistic'

import { AnketaCell } from './components/AnketaCell'
import { EditLogisticModal } from './components/Edit'
import { EditLogisticCell } from './components/EditLogisticCell'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'

export const FillialsAppsPage = () => {
  const { params, setParam, resetParams } = useLogisticFilters()
  const [selectedRow, setSelectedRow] = React.useState<LogisticShortObject>()
  const [fetch, fetchState] = logisticApi.useLazyGetBranchesApplicationsQuery()
  logisticApi.useGetProjectsQuery()
  // logisticApi.useGetDeliverymensQuery()

  React.useEffect(() => {
    fetch(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.offset])

  const onSubmit = () => {
    fetch(params)
  }
  const reset = () => {
    resetParams()
    fetch(params)
  }

  return (
    <>
      <AppLayoutTable
        title="Заявки Филлиалов/СК"
        header={<Filters onSubmit={onSubmit} reset={reset} />}
        statistics={<Statistics />}
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              loading={fetchState.isFetching}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRow?.id,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID Карты',
                  key: 'barcode',
                  width: 50,
                },
                {
                  data: 'Дата',
                  key: 'emboss_date',
                  render: (_, data) => {
                    if (data.emboss_date) {
                      return format(
                        new Date(data.emboss_date),
                        'yyyy-MM-dd HH:mm',
                      )
                    }
                  },
                  width: 50,
                },
                {
                  data: 'Автор',
                  key: 'author',
                  width: 50,
                },
                {
                  data: 'Ф.И.О.',
                  key: 'client_full_name',
                  width: 50,
                },
                {
                  data: 'Адрес доставки',
                  key: 'address',
                  width: 50,
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, item) =>
                    item.status ? LOGISTIC_STATUS_TEXT[item.status] : '-',
                  width: 50,
                },
                {
                  data: '',
                  key: 'anketa_file',
                  render: (_, item) => <AnketaCell logisticCart={item} />,
                },
                {
                  data: '',
                  key: 'id',
                  render: (_, item) => (
                    <EditLogisticCell
                      logisticCart={item}
                      setSelectedRow={setSelectedRow}
                    />
                  ),
                },
              ]}
            />

            <AppPagination
              forcePage={params.offset! / params.limit!}
              onPageChange={nextPage => {
                setParam('offset', String((nextPage - 1) * params.limit!))
              }}
              count={fetchState.data.count / params.limit!}
            />

            {selectedRow && (
              <EditLogisticModal
                data={selectedRow}
                onClose={() => setSelectedRow(undefined)}
              />
            )}
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
